import { z } from "zod";
import { PartialUserFieldsSchema } from "./User";
import { TaskFieldsSchema } from "./Task";

export const UserUserAbsenceFieldsSchema = z.object({
  id: z.number(),
  dateFrom: z.string(),
  dateTo: z.string(),
  applicationType: z.number(),
  status: z.number(),
  dateOfSubmission: z.string(),
  applicantNotes: z.string(),
  accepteeNotes: z.string(),
  user: PartialUserFieldsSchema,
  acceptingUser: PartialUserFieldsSchema,
  task: TaskFieldsSchema,
});
export const PartialUserUserAbsenceFieldsSchema =
  UserUserAbsenceFieldsSchema.deepPartial();

export type UserUserAbsenceFields = z.infer<typeof UserUserAbsenceFieldsSchema>;
export type PartialUserUserAbsenceFields = z.infer<
  typeof PartialUserUserAbsenceFieldsSchema
>;
export type UserUserAbsence = z.infer<typeof UserUserAbsenceFieldsSchema>;
